export const loadHomeGraphData = (user) => {
  return async (dispatch) => {
    try {
      const { graphs } = await import("lib/magiclinks-api");
      const response = await graphs.getHome();
      if (response.success && response.data) {
        dispatch({ type: "SET_HOME_GRAPH_DATA", data: response.data });
      } else {
        throw new Error(response.error || "Failed to fetch home graph data");
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const loadRecentLinksData = () => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_RECENT_LINKS_DATA_REQUEST" });
    try {
      const { stats } = await import("lib/magiclinks-api");
      const response = await stats.getRecentLinks();
      if (response.success && response.data) {
        dispatch({ type: "SET_RECENT_LINKS_DATA", data: response.data });
      } else {
        throw new Error(response.error || "Failed to fetch recent links");
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const loadFeaturedRetailersData = (slug) => {
  return async (dispatch) => {
    try {
      const { retailers } = await import("lib/magiclinks-api");
      const response = await retailers.getFeatured(slug);
      if (response.success && response.data) {
        dispatch({ type: "SET_FEATURED_RETAILERS_DATA", data: response.data });
      } else {
        throw new Error(response.error || "Failed to fetch featured retailers");
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const createLink = ({ ...params }, callback) => {
  return async (dispatch) => {
    //Reduces handle this to set isLoading
    dispatch({ type: "SET_LINK_REQUEST" });

    try {
      const { links } = await import("lib/magiclinks-api");
      const response = await links.create({
        url: params.url,
        source: params.mlSource || 1,
        noqueue: false,
      });
      if (response.success && response.data) {
        dispatch({ type: "SET_LINK_SUCCESS", data: response.data });
        if (typeof callback === "function") callback(response.data);
      } else {
        throw new Error(response.error || "Failed to create link");
      }
    } catch (err) {
      dispatch({ type: "SET_LINK_FAILURE", err });
    }
  };
};

export const loadStats = (user) => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_USER_STATS_REQUEST" });
    try {
      const { stats } = await import("lib/magiclinks-api");
      const response = await stats.getAllTimeTotals();
      if (response.success && response.data) {
        dispatch({ type: "SET_USER_STATS", data: response.data });
      } else {
        throw new Error(response.error || "Failed to fetch stats");
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const loadCountries = () => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_COUNTRIES_REQUEST" });

    try {
      const { countries } = await import("lib/magiclinks-api");
      const response = await countries.getIndex();
      if (response.success && response.data) {
        dispatch({ type: "LOAD_COUNTRIES_SUCCESS", data: response.data });
      } else {
        dispatch({
          type: "LOAD_COUNTRIES_FAILURE",
          err: response.error,
        });
      }
    } catch (err) {
      dispatch({ type: "LOAD_COUNTRIES_FAILURE", err });
    }
  };
};

export const getCurrentUser = () => {
  return async (dispatch) => {
    dispatch({ type: "SET_CURRENT_USER_DATA_REQUEST" });

    try {
      const { profiles } = await import("lib/magiclinks-api");
      const response = await profiles.getAccount();
      if (response.success && response.data) {
        const data = response.data;
        if (data?.user?.has_options) {
          dispatch(getIsMobileSigninAs());
        }
        dispatch({ type: "SET_CURRENT_USER_DATA_SUCCESS", data });

        // Auto-authenticate with magiclinks-api if user data is available
        if (data?.user?.email) {
          dispatch(initMagiclinksApiAuth(data.user));
        }
      } else {
        dispatch({
          type: "SET_CURRENT_USER_DATA_FAILURE",
          err: response.error,
        });
      }
    } catch (err) {
      dispatch({ type: "SET_CURRENT_USER_DATA_FAILURE", err });
    }
  };
};

/**
 * Initialize magiclinks-api authentication
 * Validates existing token from localStorage if present
 */
export const initMagiclinksApiAuth = (user) => {
  return async (dispatch) => {
    // Import dynamically to avoid circular dependencies
    const { auth, tokenStorage } = await import("lib/magiclinks-api");
    const {
      MAGICLINKS_API_LOGIN_SUCCESS,
      MAGICLINKS_API_LOGOUT,
      MAGICLINKS_API_VALIDATE_TOKEN_SUCCESS,
    } = await import("consts/actionTypes");

    // Check for existing token in localStorage
    const token = tokenStorage.getToken();

    // If we have a token, validate it
    if (token) {
      const validation = await auth.validateToken();
      if (validation.success && validation.user) {
        tokenStorage.setUser(validation.user);
        dispatch({
          type: MAGICLINKS_API_VALIDATE_TOKEN_SUCCESS,
          payload: { user: validation.user },
        });
        return;
      }
      // Token invalid, clear it
      tokenStorage.clearAuth();
    }

    // No valid token available
    dispatch({ type: MAGICLINKS_API_LOGOUT });
  };
};

export const loadUserData = (user_id, token) => {
  return async (dispatch) => {
    dispatch({ type: "SET_SWITCH_USER_DATA_REQUEST" });

    try {
      const { userOptions } = await import("lib/magiclinks-api");
      const response = await userOptions.modify(user_id);
      if (response.success && response.data) {
        dispatch({ type: "SET_SWITCH_USER_DATA_SUCCESS", data: response.data });
      } else {
        dispatch({
          type: "SET_SWITCH_USER_DATA_FAILURE",
          err: response.error,
        });
      }
    } catch (err) {
      dispatch({ type: "SET_SWITCH_USER_DATA_FAILURE", err });
    }
  };
};

export const getUserList = (text_search, user) => {
  return async (dispatch) => {
    var local_type = "SET_MANAGER_USER_LIST_DATA";
    if (typeof user == "undefined") {
      user = "";
      local_type = "SET_USER_LIST_DATA";
    }

    try {
      const { userOptions } = await import("lib/magiclinks-api");
      const params = {};
      if (typeof text_search != "undefined" && text_search != null) {
        params.text = text_search;
      }
      if (user) {
        params.user = String(user);
      }
      const response = await userOptions.getIndex(params);
      if (response.success && response.data) {
        dispatch({ type: local_type, data: response.data });
      } else {
        dispatch({ type: "LOAD_DATA_FAILURE", err: response.error });
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const showNotification = (status, message) => {
  return (dispatch) => {
    dispatch({ type: "SHOW_NOTIFICATION", status, message });
  };
};

export const hideNotification = () => {
  return (dispatch) => {
    dispatch({ type: "HIDE_NOTIFICATION", status: null, message: null });
  };
};

export const getDeiOptions = (type) => {
  return async (dispatch) => {
    dispatch({ type: "LOAD_DEI_OPTIONS_REQUEST" });

    try {
      const { profiles } = await import("lib/magiclinks-api");
      const response = await profiles.getDeiOptions(type);
      if (response.success && response.data) {
        dispatch({
          type: "LOAD_DEI_OPTIONS_SUCCESS",
          data: response.data,
          deiType: type,
        });
      } else {
        dispatch({ type: "LOAD_DATA_FAILURE", err: response.error });
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const getTipaltiInformation = (token) => {
  return async (dispatch) => {
    try {
      const { tipalti } = await import("lib/magiclinks-api");
      const response = await tipalti.getIndex();
      if (response.success && response.data) {
        dispatch({
          type: "SET_TIPALTI_INFORMATION_SUCCESS",
          data: response.data,
        });
      } else {
        dispatch({ type: "LOAD_DATA_FAILURE", err: response.error });
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const saveCurrentUser = (current_user, token, slug) => {
  return async (dispatch) => {
    dispatch({ type: "SET_CURRENT_USER_DATA_REQUEST" });

    try {
      const { profiles, obsessedPages } = await import("lib/magiclinks-api");

      if (slug) {
        const slugResponse = await obsessedPages.changeSlug(slug);
        if (!slugResponse.success || slugResponse.data?.error) {
          const error = slugResponse.data?.error || slugResponse.error;
          dispatch({ type: "SET_SLUG_FAILURE", error });
          dispatch({
            type: "SHOW_NOTIFICATION",
            status: "alert",
            message: `${error || "Error updating."}`,
          });
          setTimeout(() => {
            dispatch({
              type: "HIDE_NOTIFICATION",
              status: null,
              message: null,
            });
          }, 4000);
          return;
        }
        dispatch({ type: "SET_SLUG_SUCCESS", data: slugResponse.data });
      }

      const response = await profiles.updateAccount(current_user);
      if (response.success && response.data) {
        const data = response.data;
        dispatch({ type: "SET_CURRENT_USER_DATA_SUCCESS", data });
        const errorMessage = data.errors || null;
        if (!errorMessage) {
          dispatch({
            type: "SHOW_NOTIFICATION",
            status: "success",
            message: "Your account settings have been updated.",
          });
        } else {
          dispatch({
            type: "SHOW_NOTIFICATION",
            status: "alert",
            message: `${errorMessage || "Error updating."}`,
          });
        }
      } else {
        dispatch({
          type: "SET_CURRENT_USER_DATA_FAILURE",
          err: response.error,
        });
      }
      setTimeout(() => {
        dispatch({
          type: "HIDE_NOTIFICATION",
          status: null,
          message: null,
        });
      }, 4000);
    } catch (err) {
      dispatch({ type: "SET_CURRENT_USER_DATA_FAILURE", err });
    }
  };
};

export const updateUserPassword = (currentUser, token, callback) => {
  return async (dispatch) => {
    dispatch({ type: "UPDATE_USER_PASSWORD_REQUEST" });

    try {
      const { profiles } = await import("lib/magiclinks-api");
      const response = await profiles.updateAccount(currentUser);
      if (response.success && response.data) {
        const data = response.data;
        if (!data.errors) {
          dispatch({ type: "UPDATE_USER_PASSWORD_SUCCESS", data });
          dispatch({
            type: "SHOW_PASSWORD_NOTIFICATION",
            status: "success",
            message: "Your password has been updated.",
          });
          if (typeof callback === "function") {
            callback();
          }
        } else {
          dispatch({
            type: "UPDATE_USER_PASSWORD_FAILURE",
            error: data.errors,
          });
        }
      } else {
        dispatch({
          type: "UPDATE_USER_PASSWORD_FAILURE",
          err: response.error,
        });
      }
      setTimeout(() => {
        dispatch({
          type: "HIDE_NOTIFICATION",
          status: null,
          message: null,
        });
      }, 4000);
    } catch (err) {
      dispatch({ type: "UPDATE_USER_PASSWORD_FAILURE", err });
    }
  };
};

export const updatePayment = (confirmationCode, paymentInfo, callback) => {
  return async (dispatch) => {
    dispatch({ type: "SET_PAYMENT_INFO_REQUEST" });

    try {
      const { profiles } = await import("lib/magiclinks-api");
      const response = await profiles.updatePayment({
        code: confirmationCode,
        user: {
          rewards_payment_info: paymentInfo,
        },
      });
      if (response.success && response.data) {
        const data = response.data;
        if ("error" in data) {
          dispatch({ type: "SET_PAYMENT_INFO_FAILURE", data });
          if (typeof callback === "function") callback(data);
        } else {
          dispatch({ type: "SET_CURRENT_USER_DATA_SUCCESS", data });
          if (typeof callback === "function") callback(data);
        }
      } else {
        dispatch({
          type: "SET_PAYMENT_INFO_FAILURE",
          err: response.error,
        });
      }
    } catch (err) {
      dispatch({ type: "SET_PAYMENT_INFO_FAILURE", err });
    }
  };
};

export const saveCurrentUserTaxFormStatus = (current_user, token) => {
  return async (dispatch) => {
    dispatch({ type: "SET_CURRENT_USER_DATA_REQUEST" });

    try {
      const { profiles } = await import("lib/magiclinks-api");
      const response = await profiles.updateAccount({
        user: current_user.user,
      });
      if (response.success && response.data) {
        dispatch({
          type: "SET_CURRENT_USER_DATA_SUCCESS",
          data: response.data,
        });
      } else {
        dispatch({
          type: "SET_CURRENT_USER_DATA_FAILURE",
          err: response.error,
        });
      }
      setTimeout(() => {
        dispatch({
          type: "HIDE_NOTIFICATION",
          status: null,
          message: null,
        });
      }, 4000);
    } catch (err) {
      dispatch({ type: "SET_CURRENT_USER_DATA_FAILURE", err });
    }
  };
};

// Note: saveAvatar uses FormData for file uploads.
export const saveAvatar = (pageId, avatar, avatarOriginal) => {
  return async (dispatch) => {
    dispatch({ type: "SET_CURRENT_USER_DATA_REQUEST" });
    dispatch({ type: "SET_CHANGE_PROFILE_IMAGE_REQUEST" });

    try {
      const { profiles } = await import("lib/magiclinks-api");
      const response = await profiles.saveAvatar(avatar);
      if (response.success && response.data) {
        dispatch({
          type: "SET_CURRENT_USER_DATA_SUCCESS",
          data: response.data,
        });
        dispatch({ type: "SET_CHANGE_PROFILE_IMAGE_SUCCESS" });
      } else {
        dispatch({
          type: "SET_CURRENT_USER_DATA_FAILURE",
          err: response.error,
        });
      }
    } catch (err) {
      dispatch({ type: "SET_CURRENT_USER_DATA_FAILURE", err });
    }
  };
};

export const removeAvatar = () => {
  return async (dispatch) => {
    dispatch({ type: "SET_CURRENT_USER_DATA_REQUEST" });
    dispatch({ type: "SET_CHANGE_PROFILE_IMAGE_REQUEST" });

    try {
      const { profiles } = await import("lib/magiclinks-api");
      const response = await profiles.removeAvatar();
      if (response.success && response.data) {
        dispatch({
          type: "SET_CURRENT_USER_DATA_SUCCESS",
          data: response.data,
        });
        dispatch({ type: "SET_CHANGE_PROFILE_IMAGE_SUCCESS" });
      } else {
        dispatch({
          type: "SET_CURRENT_USER_DATA_FAILURE",
          err: response.error,
        });
      }
    } catch (err) {
      dispatch({ type: "SET_CURRENT_USER_DATA_FAILURE", err });
    }
  };
};

export const loadMerchants = () => {
  return async (dispatch) => {
    dispatch({ type: "SET_MERCHANTS_REQUEST" });

    try {
      const { merchants } = await import("lib/magiclinks-api");
      const response = await merchants.getIndex();
      if (response.success && response.data) {
        dispatch({ type: "SET_MERCHANTS_SUCCESS", data: response.data });
      } else {
        dispatch({ type: "LOAD_DATA_FAILURE", err: response.error });
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const setRewardsUserPreferences = (preferences) => {
  return async (dispatch) => {
    try {
      const { helpPreferences } = await import("lib/magiclinks-api");
      const response = await helpPreferences.create(preferences);
      if (response.success && response.data) {
        dispatch({
          type: "SET_REWARDS_USER_PREFERENCES",
          data: response.data,
        });
      } else {
        dispatch({ type: "LOAD_DATA_FAILURE", err: response.error });
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const getRewardsUserPreferences = () => {
  return async (dispatch) => {
    dispatch({ type: "SET_REWARDS_USER_PREFERENCES_REQUEST" });

    try {
      const { helpPreferences } = await import("lib/magiclinks-api");
      const response = await helpPreferences.getIndex();
      if (response.success && response.data) {
        dispatch({
          type: "SET_REWARDS_USER_PREFERENCES",
          data: response.data,
        });
      } else {
        dispatch({ type: "LOAD_DATA_FAILURE", err: response.error });
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const checkRewardsUserSignedIn = (redirectToLogin = false) => {
  return async (dispatch) => {
    try {
      const { profiles } = await import("lib/magiclinks-api");
      const response = await profiles.getSignedIn();
      if (response.success && response.data) {
        if (redirectToLogin && !response.data.signed_in) {
          window.location.href = "/rewards_users/login";
        } else {
          dispatch({
            type: "SET_REWARDS_USER_SIGNED_IN",
            data: response.data,
          });
        }
      } else {
        dispatch({ type: "LOAD_DATA_FAILURE", err: response.error });
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const getIsMobileSigninAs = () => {
  return async (dispatch) => {
    try {
      const { userOptions } = await import("lib/magiclinks-api");
      const response = await userOptions.getMobileSigninAs();
      if (response.success && response.data) {
        dispatch({ type: "SET_IS_MOBILE_SIGNIN_AS", data: response.data });
      } else {
        dispatch({ type: "LOAD_DATA_FAILURE", err: response.error });
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const updateIsMobileSigninAs = (isMobileSigninAs) => {
  return async (dispatch) => {
    try {
      const { userOptions } = await import("lib/magiclinks-api");
      const response = await userOptions.updateMobileSigninAs(isMobileSigninAs);
      if (response.success && response.data) {
        dispatch({ type: "SET_IS_MOBILE_SIGNIN_AS", data: response.data });
      } else {
        dispatch({ type: "LOAD_DATA_FAILURE", err: response.error });
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const getUserSocialChannels = () => {
  return async (dispatch) => {
    try {
      const { profiles } = await import("lib/magiclinks-api");
      const response = await profiles.getValidChannels();
      if (response.success && response.data) {
        dispatch({
          type: "SET_USER_SOCIAL_CHANNELS_SUCCESS",
          data: response.data,
        });
      } else {
        dispatch({ type: "LOAD_DATA_FAILURE", err: response.error });
      }
    } catch (err) {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    }
  };
};

export const validateSocialChannel = (channel, callback) => {
  return async (dispatch) => {
    try {
      const { profiles } = await import("lib/magiclinks-api");
      const response = await profiles.validateChannel(channel);
      if (response.success && response.data) {
        if (callback && typeof callback === "function") callback(response.data);
      } else {
        if (callback && typeof callback === "function")
          callback({ error: response.error });
      }
    } catch (err) {
      if (callback && typeof callback === "function") callback({ error: err });
    }
  };
};
